var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7105 0.55957C8.10453 0.55957 0.314697 8.38772 0.314697 18.0409C0.314697 27.6941 8.10453 35.5223 17.7105 35.5223C27.3165 35.5223 35.1063 27.6941 35.1063 18.0409C35.1063 8.38772 27.3165 0.55957 17.7105 0.55957ZM12.6555 26.9865H8.41881V14.1777H12.6555V26.9865ZM10.5373 12.4286H10.5097C9.08799 12.4286 8.16851 11.4451 8.16851 10.216C8.16851 8.95908 9.11612 8.00281 10.5654 8.00281C12.0147 8.00281 12.9066 8.95908 12.9342 10.216C12.9342 11.4451 12.0147 12.4286 10.5373 12.4286ZM27.932 26.9865H23.6959V20.1341C23.6959 18.412 23.0825 17.2375 21.5495 17.2375C20.3792 17.2375 19.6822 18.0297 19.3759 18.7945C19.2639 19.0682 19.2365 19.4507 19.2365 19.8335V26.9865H15.0001C15.0001 26.9865 15.0556 15.3794 15.0001 14.1777H19.2365V15.9913C19.7995 15.1185 20.8069 13.8771 23.0546 13.8771C25.842 13.8771 27.932 15.7077 27.932 19.6419V26.9865Z",
    fill: "#2E1A47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_1526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7916,
    height: 34.9627,
    fill: "white",
    transform: "translate(0.314697 0.55957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3484f9b963364bb25fce0d259eb9bee2.svg";
export { ForwardRef as ReactComponent };